import { Alert, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { BuyTogetherEffect } from '../../../../../typings'
import { messages } from '../messages'

type Props = {
  buyTogether: BuyTogetherEffect
}

export function BuyTogetherRecap(props: Props) {
  const {
    buyTogether: { trigger, benefit },
  } = props

  if (!trigger || !benefit) return null

  return (
    <Alert variant="info">
      <FormattedMessage
        {...messages.buyTogether.recap}
        values={{
          buyMinCount: trigger.minQuantity,
          discountListOne: trigger.discount,
          discountListTwo: benefit.discount,
          b: (content) => <Text variant="action1">{content}</Text>,
        }}
      />
    </Alert>
  )
}
